/**
 * @author Saad <mohammed.saadullah@314ecorp.com>
 * @description posthog utils
 */

import { FARO_INTEGRATION_URL, FARO_PRODUCTION_URL } from './url';

const URL_BLOCKLIST = [
	FARO_INTEGRATION_URL,
	FARO_PRODUCTION_URL,
	'https://api.marker.io',
	'https://s3.eu-west-1.amazonaws.com/marker.sessions.prod',
	'https://edge.marker.io',
];

// posthog's own events to block
const POSTHOG_EVENTS_TO_BLOCK = [
	'$pageleave',
	'survey dismissed',
	'survey sent',
	'survey shown',
	'$create_alias',
	'$$client_ingestion_warning',
	'$web_experiment_applied',
	'$feature_enrollment_update',
	'$feature_flag_called',
	'$opt_in',
	'$web_vitals',
	'$dead_click',
	'$autocapture',
	'$rageclick',
];

export { POSTHOG_EVENTS_TO_BLOCK, URL_BLOCKLIST };
